import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { createBrowserHistory } from 'history';
import reportWebVitals from './reportWebVitals';
import { Basename_url } from 'constant/app.config';
import 'swiper/swiper-bundle.min.css';
import GlobalToast from 'GlobalToast';

const container = document.getElementById('root');
const root = createRoot(container);

const history = createBrowserHistory();

root.render(
  <BrowserRouter history={history} basename={Basename_url}>
    <div className="app-scale">
      <App />
      <GlobalToast />
    </div>
  </BrowserRouter>
);

reportWebVitals();
